import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  mockCitizen,
  CitizensService,
  MunicipalEntitiesService,
  throwObjectNotFound,
  Context,
  mockCitizenDocument,
  MunicipalEntity,
} from '@prodcard/core'
import GeneratorToolCard from '../components/GeneratorToolCard.vue'
import { GeneratorTool, getRandomFromRepo } from '../components/model'
import { ref, Ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CitizensTool',
  props: {
    citizenService: {},
    municipalEntitiesService: {}
  },
  setup(__props: any) {

const props = __props;



const preloadedME: Ref<MunicipalEntity[]> = ref([])
async function getRandomPreloadedMEId(ctx: Context) {
  if (preloadedME.value.length === 0) {
    const response = await props.municipalEntitiesService.findAll(ctx)
    preloadedME.value = response.items
  }
  return preloadedME.value[Math.floor(Math.random() * preloadedME.value.length)].id
}

async function getRandomMEId(ctx: Context) {
  return (
    (await getRandomFromRepo(paging => props.municipalEntitiesService.findAll(ctx, { paging })))?.id ??
    throwObjectNotFound('<18a52e5c>')
  )
}

function getRandomCitizen(ctx: Context) {
  return getRandomFromRepo(paging => props.citizenService.findAll(ctx, { paging }))
}

const generatorTool: GeneratorTool = {
  create: async (ctx: Context) => {
    const citizen = mockCitizen()
    await props.citizenService.add(ctx, {
      ...citizen,
      municipalEntityId: await getRandomPreloadedMEId(ctx),
      documents: [mockCitizenDocument(citizen.id, citizen.birthdate)],
    })
  },
  update: async (ctx: Context) => {
    const citizen = await getRandomCitizen(ctx)
    if (!citizen) return
    const updatedCitizen = mockCitizen()
    await props.citizenService.update(ctx, citizen.id, {
      ...updatedCitizen,
      municipalEntityId: await getRandomMEId(ctx),
    })
  },
  delete: async (ctx: Context) => {
    const sp = await getRandomCitizen(ctx)
    if (!sp) return
    await props.citizenService.delete(ctx, sp.id)
  },
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GeneratorToolCard, {
    title: "Действия с гражданами",
    "generator-tool": generatorTool
  }))
}
}

})